<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">Clientes</h1>
      <p class="text-gray-600 dark:text-gray-400">Catálogo de clientes POS2</p>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <!-- Header -->
      <div class="p-4 border-b border-gray-200 dark:border-gray-700 flex flex-wrap gap-2 items-center justify-between">
        <div class="flex gap-2">
          <input
            v-model="filtros.buscar"
            @keyup.enter="buscar"
            type="text"
            placeholder="Buscar por nombre, RFC, correo..."
            class="px-3 py-2 rounded border text-sm bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200 w-72"
          />
          <button @click="buscar" class="px-4 py-2 rounded bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 transition">Buscar</button>
          <button @click="limpiar" class="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition">Limpiar</button>
        </div>
        <button
          @click="abrirModalNuevo"
          class="px-4 py-2 rounded bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 transition flex items-center gap-1"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
          Nuevo Cliente
        </button>
      </div>

      <!-- Tabla -->
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left">
          <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 text-blue-600 dark:text-blue-400 border-b-2 border-gray-200 dark:border-gray-700">
            <tr>
              <th class="px-3 py-2 w-16">ID</th>
              <th class="px-3 py-2">Nombre</th>
              <th class="px-3 py-2 w-28">Abreviatura</th>
              <th class="px-3 py-2 w-32">Tipo Cliente</th>
              <th class="px-3 py-2 w-28">RFC</th>
              <th class="px-3 py-2">Correo</th>
              <th class="px-3 py-2 w-24">Descuento</th>
              <th class="px-3 py-2 w-24">Días Crédito</th>
              <th class="px-3 py-2 w-24">Logo</th>
              <th class="px-3 py-2 w-20"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="10" class="px-4 py-8 text-center text-gray-400">Cargando...</td>
            </tr>
            <template v-else>
              <tr
                v-for="cliente in clientes"
                :key="cliente.id"
                class="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50 bg-white dark:bg-gray-800"
              >
                <td class="px-3 py-2 text-gray-500 dark:text-gray-400 text-xs">{{ cliente.id }}</td>
                <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ cliente.nombre }}</td>
                <td class="px-3 py-2 text-gray-600 dark:text-gray-300 text-xs">{{ cliente.abreviatura }}</td>
                <td class="px-3 py-2 text-gray-600 dark:text-gray-300 text-xs">{{ cliente.tipo_cliente?.nombre }}</td>
                <td class="px-3 py-2 font-mono text-gray-600 dark:text-gray-300 text-xs">{{ cliente.rfc }}</td>
                <td class="px-3 py-2 text-gray-600 dark:text-gray-400 text-xs">{{ cliente.correo }}</td>
                <td class="px-3 py-2 text-gray-600 dark:text-gray-300 text-xs">{{ cliente.descuento }}%</td>
                <td class="px-3 py-2 text-gray-600 dark:text-gray-300 text-xs">{{ cliente.dias_credito ?? 0 }}</td>
                <td class="px-3 py-2">
                  <span v-if="cliente.incluir_logo" class="text-xs bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300 px-1.5 py-0.5 rounded-full">Sí</span>
                  <span v-else class="text-xs bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400 px-1.5 py-0.5 rounded-full">No</span>
                </td>
                <td class="px-3 py-2">
                  <div class="flex gap-1">
                    <button @click="abrirModalEditar(cliente)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 p-1" title="Editar">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                    </button>
                    <button @click="eliminar(cliente)" class="text-red-500 hover:text-red-700 dark:text-red-400 p-1" title="Eliminar">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="clientes.length === 0">
                <td colspan="10" class="px-4 py-8 text-center text-gray-400">No se encontraron clientes</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      <div v-if="pagination.total > 0" class="flex justify-between items-center px-4 py-3 border-t border-gray-200 dark:border-gray-700">
        <div class="text-sm text-gray-600 dark:text-gray-400">
          Mostrando {{ ((pagination.current_page - 1) * pagination.per_page) + 1 }}
          a {{ Math.min(pagination.current_page * pagination.per_page, pagination.total) }}
          de {{ pagination.total }} registros
        </div>
        <div class="flex gap-2">
          <button @click="cambiarPagina(pagination.current_page - 1)" :disabled="pagination.current_page <= 1" class="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 text-sm disabled:opacity-50">Anterior</button>
          <span class="px-3 py-1 text-sm text-gray-600 dark:text-gray-400">Página {{ pagination.current_page }} de {{ pagination.last_page }}</span>
          <button @click="cambiarPagina(pagination.current_page + 1)" :disabled="pagination.current_page >= pagination.last_page" class="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 text-sm disabled:opacity-50">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- ===================== MODAL ===================== -->
    <div v-if="modalAbierto" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div class="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-4xl max-h-[92vh] flex flex-col">

        <!-- Modal header con tabs -->
        <div class="flex items-center justify-between px-6 pt-5 pb-0 border-b border-gray-200 dark:border-gray-700">
          <div class="flex items-center gap-6">
            <h2 class="text-lg font-bold text-gray-900 dark:text-white mr-4">
              {{ editandoId ? 'Editar Cliente' : 'Nuevo Cliente' }}
            </h2>
            <button
              @click="tab = 'datos'"
              class="pb-3 text-sm font-semibold border-b-2 transition-colors"
              :class="tab === 'datos' ? 'border-violet-600 text-violet-600' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
            >
              Datos del Cliente
            </button>
            <button
              @click="tab = 'vendedores'"
              class="pb-3 text-sm font-semibold border-b-2 transition-colors flex items-center gap-1.5"
              :class="tab === 'vendedores' ? 'border-violet-600 text-violet-600' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
            >
              Vendedores Default
              <span v-if="vendedoresAsignados.length" class="text-xs bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300 px-1.5 py-0.5 rounded-full font-semibold">
                {{ vendedoresAsignados.length }}
              </span>
            </button>
          </div>
          <button @click="cerrarModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 mb-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </div>

        <!-- Modal body -->
        <div class="overflow-y-auto flex-1 px-6 py-5">

          <!-- Error global -->
          <div v-if="formError" class="mb-4 px-4 py-2 text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded">
            {{ formError }}
          </div>

          <!-- ---- TAB: DATOS ---- -->
          <div v-show="tab === 'datos'">
            <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Datos principales</p>
            <div class="grid grid-cols-2 gap-4 mb-5">
              <div class="col-span-2">
                <label class="form-label">Nombre <span class="text-red-500">*</span></label>
                <input v-model="form.nombre" type="text" maxlength="150" class="input-field" />
              </div>
              <div>
                <label class="form-label">Tipo de Cliente <span class="text-red-500">*</span></label>
                <select v-model="form.tipo_cliente_id" class="input-field">
                  <option :value="null" disabled>Selecciona...</option>
                  <option v-for="t in tiposCliente" :key="t.id" :value="t.id">{{ t.nombre }}</option>
                </select>
              </div>
              <div>
                <label class="form-label">Abreviatura</label>
                <input v-model="form.abreviatura" type="text" maxlength="30" class="input-field" />
              </div>
              <div>
                <label class="form-label">Correo <span class="text-red-500">*</span></label>
                <input v-model="form.correo" type="email" maxlength="150" class="input-field" />
              </div>
              <div>
                <label class="form-label">Teléfono</label>
                <input v-model="form.telefono" type="text" maxlength="30" class="input-field" />
              </div>
              <div>
                <label class="form-label">RFC</label>
                <input v-model="form.rfc" type="text" maxlength="13" class="input-field font-mono uppercase" @input="form.rfc = form.rfc.toUpperCase()" />
              </div>
              <div>
                <label class="form-label">Régimen Fiscal <span class="text-gray-400 font-normal text-xs">(clave SAT)</span></label>
                <select v-model="form.regimen_fiscal" class="input-field">
                  <option value="">Selecciona...</option>
                  <option value="601">601 – General de Ley Personas Morales</option>
                  <option value="603">603 – Personas Morales sin Fines de Lucro</option>
                  <option value="612">612 – Personas Físicas con Actividades Empresariales</option>
                  <option value="616">616 – Sin obligaciones fiscales</option>
                  <option value="621">621 – Incorporación Fiscal</option>
                  <option value="625">625 – Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
                  <option value="626">626 – Simplificado de Confianza (RESICO)</option>
                </select>
              </div>
              <div>
                <label class="form-label">Uso CFDI <span class="text-gray-400 font-normal text-xs">(predeterminado)</span></label>
                <select v-model="form.uso_cfdi" class="input-field">
                  <option value="">Selecciona...</option>
                  <option value="G01">G01 – Adquisición de mercancias</option>
                  <option value="G03">G03 – Gastos en general</option>
                  <option value="P01">P01 – Por definir</option>
                  <option value="S01">S01 – Sin efectos fiscales</option>
                  <option value="CP01">CP01 – Pagos</option>
                </select>
              </div>
              <div>
                <label class="form-label">CP Fiscal <span class="text-gray-400 font-normal text-xs">(domicilio SAT)</span></label>
                <input v-model="form.codigo_postal_fiscal" type="text" maxlength="5" class="input-field font-mono" placeholder="00000" />
              </div>
              <div>
                <label class="form-label">Descuento (%) <span class="text-red-500">*</span></label>
                <input v-model="form.descuento" type="number" min="0" max="100" step="0.01" class="input-field" />
              </div>
              <div>
                <label class="form-label">Días de Crédito</label>
                <input v-model="form.dias_credito" type="number" min="0" step="1" class="input-field" />
              </div>
              <div class="col-span-2">
                <label class="form-label">Descripción</label>
                <input v-model="form.descripcion" type="text" maxlength="255" class="input-field" />
              </div>
              <div class="col-span-2 flex items-center gap-3">
                <label class="form-label mb-0">Incluir Logo</label>
                <button type="button" @click="form.incluir_logo = !form.incluir_logo"
                  class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors"
                  :class="form.incluir_logo ? 'bg-violet-600' : 'bg-gray-300 dark:bg-gray-600'"
                >
                  <span class="inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform" :class="form.incluir_logo ? 'translate-x-4' : 'translate-x-1'"></span>
                </button>
                <span class="text-xs text-gray-500 dark:text-gray-400">{{ form.incluir_logo ? 'Sí' : 'No' }}</span>
              </div>
            </div>

            <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Dirección</p>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="form-label">Calle</label>
                <input v-model="form.calle" type="text" maxlength="150" class="input-field" />
              </div>
              <div>
                <label class="form-label">Número Exterior</label>
                <input v-model="form.num_exterior" type="text" maxlength="20" class="input-field" />
              </div>
              <div>
                <label class="form-label">Colonia</label>
                <input v-model="form.colonia" type="text" maxlength="100" class="input-field" />
              </div>
              <div>
                <label class="form-label">Código Postal</label>
                <input v-model="form.codigo_postal" type="text" maxlength="10" class="input-field" />
              </div>
              <div>
                <label class="form-label">Población</label>
                <input v-model="form.poblacion" type="text" maxlength="100" class="input-field" />
              </div>
              <div>
                <label class="form-label">Municipio</label>
                <input v-model="form.municipio" type="text" maxlength="100" class="input-field" />
              </div>
              <div>
                <label class="form-label">Estado</label>
                <input v-model="form.estado" type="text" maxlength="100" class="input-field" />
              </div>
              <div>
                <label class="form-label">País</label>
                <input v-model="form.pais" type="text" maxlength="100" class="input-field" />
              </div>
            </div>
          </div>

          <!-- ---- TAB: VENDEDORES ---- -->
          <div v-show="tab === 'vendedores'">
            <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Selecciona los empleados que serán vendedores por defecto para este cliente.
            </p>

            <div class="grid grid-cols-2 gap-4">
              <!-- Disponibles -->
              <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                  <span class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Disponibles</span>
                  <span class="text-xs text-gray-400">{{ empleadosDisponibles.length }}</span>
                </div>
                <input
                  v-model="buscarEmpleado"
                  type="text"
                  placeholder="Filtrar empleados..."
                  class="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-violet-300"
                />
                <div class="border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden">
                  <div class="overflow-y-auto h-56 divide-y divide-gray-100 dark:divide-gray-700">
                    <div
                      v-for="emp in empleadosFiltrados"
                      :key="emp.id"
                      @click="toggleSeleccionDisponible(emp.id)"
                      class="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-violet-50 dark:hover:bg-violet-900/20 transition-colors select-none"
                      :class="seleccionDisponibles.includes(emp.id) ? 'bg-violet-50 dark:bg-violet-900/20' : ''"
                    >
                      <div class="w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors"
                        :class="seleccionDisponibles.includes(emp.id) ? 'bg-violet-600 border-violet-600' : 'border-gray-300 dark:border-gray-500'"
                      >
                        <svg v-if="seleccionDisponibles.includes(emp.id)" class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/></svg>
                      </div>
                      <div class="min-w-0">
                        <p class="text-sm text-gray-800 dark:text-gray-200 truncate">{{ emp.nombre }} {{ emp.apellido_paterno }}</p>
                        <p v-if="emp.apellido_materno" class="text-xs text-gray-400 truncate">{{ emp.apellido_materno }}</p>
                      </div>
                    </div>
                    <div v-if="empleadosFiltrados.length === 0" class="px-3 py-6 text-center text-sm text-gray-400">
                      Sin empleados disponibles
                    </div>
                  </div>
                </div>
                <button
                  @click="seleccionarTodosDisponibles"
                  class="text-xs text-violet-600 hover:text-violet-800 dark:text-violet-400 text-left"
                >
                  Seleccionar todos
                </button>
              </div>

              <!-- Botones del centro -->
              <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                  <span class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Asignados</span>
                  <span class="text-xs text-gray-400">{{ vendedoresAsignados.length }}</span>
                </div>

                <!-- Controles mover -->
                <div class="flex gap-2 items-start">
                  <div class="flex flex-col gap-1.5 pt-0.5">
                    <button @click="agregarSeleccionados" title="Agregar seleccionados"
                      class="p-1.5 rounded bg-violet-600 text-white hover:bg-violet-700 transition disabled:opacity-40"
                      :disabled="seleccionDisponibles.length === 0"
                    >
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"/></svg>
                    </button>
                    <button @click="agregarTodos" title="Agregar todos"
                      class="p-1.5 rounded bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300 hover:bg-violet-200 dark:hover:bg-violet-900/50 transition"
                    >
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M13 5l7 7-7 7M5 5l7 7-7 7"/></svg>
                    </button>
                    <button @click="quitarSeleccionados" title="Quitar seleccionados"
                      class="p-1.5 rounded bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500 transition disabled:opacity-40"
                      :disabled="seleccionAsignados.length === 0"
                    >
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7"/></svg>
                    </button>
                    <button @click="quitarTodos" title="Quitar todos"
                      class="p-1.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600 transition"
                    >
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M11 19l-7-7 7-7M19 19l-7-7 7-7"/></svg>
                    </button>
                  </div>

                  <!-- Lista asignados -->
                  <div class="flex-1 border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden">
                    <div class="overflow-y-auto h-56 divide-y divide-gray-100 dark:divide-gray-700">
                      <div
                        v-for="emp in vendedoresAsignados"
                        :key="emp.id"
                        @click="toggleSeleccionAsignado(emp.id)"
                        class="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors select-none"
                        :class="seleccionAsignados.includes(emp.id) ? 'bg-red-50 dark:bg-red-900/10' : ''"
                      >
                        <div class="w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors"
                          :class="seleccionAsignados.includes(emp.id) ? 'bg-red-500 border-red-500' : 'border-gray-300 dark:border-gray-500'"
                        >
                          <svg v-if="seleccionAsignados.includes(emp.id)" class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/></svg>
                        </div>
                        <div class="min-w-0 flex-1">
                          <p class="text-sm text-gray-800 dark:text-gray-200 truncate">{{ emp.nombre }} {{ emp.apellido_paterno }}</p>
                          <p v-if="emp.apellido_materno" class="text-xs text-gray-400 truncate">{{ emp.apellido_materno }}</p>
                        </div>
                        <span class="text-xs bg-violet-100 text-violet-600 dark:bg-violet-900/30 dark:text-violet-300 px-1.5 py-0.5 rounded-full flex-shrink-0">Vendedor</span>
                      </div>
                      <div v-if="vendedoresAsignados.length === 0" class="px-3 py-6 text-center text-sm text-gray-400">
                        Sin vendedores asignados
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  @click="seleccionarTodosAsignados"
                  class="text-xs text-red-500 hover:text-red-700 dark:text-red-400 text-right"
                >
                  Seleccionar todos para quitar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal footer -->
        <div class="flex justify-between items-center gap-2 px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <div class="text-xs text-gray-400">
            <span v-if="tab === 'vendedores'">
              {{ vendedoresAsignados.length }} vendedor(es) asignado(s)
            </span>
          </div>
          <div class="flex gap-2">
            <button @click="cerrarModal" class="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition">Cancelar</button>
            <button @click="guardar" :disabled="guardando" class="px-5 py-2 rounded bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 transition disabled:opacity-60">
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useHttp } from '@/composables/useHttp.js'
import Swal from 'sweetalert2'

const httpClientes     = useHttp()
const httpTiposCliente = useHttp()
const httpEmpleados    = useHttp()
const httpVendedores   = useHttp()

const clientes     = ref([])
const tiposCliente = ref([])
const todosEmpleados = ref([])
const loading      = ref(false)
const guardando    = ref(false)
const filtros      = ref({ buscar: '' })
const pagination   = ref({ current_page: 1, last_page: 1, per_page: 15, total: 0 })

const modalAbierto = ref(false)
const editandoId   = ref(null)
const formError    = ref('')
const tab          = ref('datos')

// Vendedores
const vendedoresAsignados  = ref([])   // objetos empleado asignados
const seleccionDisponibles = ref([])   // ids seleccionados en lista izquierda
const seleccionAsignados   = ref([])   // ids seleccionados en lista derecha
const buscarEmpleado       = ref('')

// IDs de asignados para calcular disponibles
const idsAsignados = computed(() => vendedoresAsignados.value.map(e => e.id))

const empleadosDisponibles = computed(() =>
  todosEmpleados.value.filter(e => !idsAsignados.value.includes(e.id))
)

const empleadosFiltrados = computed(() => {
  const q = buscarEmpleado.value.toLowerCase()
  if (!q) return empleadosDisponibles.value
  return empleadosDisponibles.value.filter(e =>
    `${e.nombre} ${e.apellido_paterno} ${e.apellido_materno ?? ''}`.toLowerCase().includes(q)
  )
})

const formVacio = () => ({
  nombre: '', tipo_cliente_id: null, rfc: '', regimen_fiscal: '',
  uso_cfdi: '', codigo_postal_fiscal: '',
  descripcion: '', abreviatura: '', correo: '', descuento: 0,
  dias_credito: 0, calle: '', num_exterior: '', colonia: '',
  codigo_postal: '', poblacion: '', municipio: '', estado: '',
  pais: 'México', telefono: '', incluir_logo: false,
})

const form = ref(formVacio())

// ---- Carga inicial ----
const cargarTiposCliente = async () => {
  await httpTiposCliente.get('/pos2/tipos-cliente?per_page=200')
  tiposCliente.value = httpTiposCliente.data.value?.data ?? []
}

const cargarEmpleados = async () => {
  // Solo empleados marcados como vendedores (es_vendedor = true)
  await httpEmpleados.get('/pos2/empleados?per_page=500&solo_vendedores=1')
  todosEmpleados.value = httpEmpleados.data.value?.data ?? []
}

const cargar = async (pagina = 1) => {
  try {
    loading.value = true
    const params = new URLSearchParams({ page: pagina, per_page: pagination.value.per_page })
    if (filtros.value.buscar) params.append('buscar', filtros.value.buscar)
    await httpClientes.get(`/pos2/clientes?${params}`)
    clientes.value = httpClientes.data.value.data
    pagination.value = {
      current_page: httpClientes.data.value.current_page,
      last_page:    httpClientes.data.value.last_page,
      per_page:     httpClientes.data.value.per_page,
      total:        httpClientes.data.value.total,
    }
  } finally {
    loading.value = false
  }
}

const buscar        = () => cargar(1)
const limpiar       = () => { filtros.value.buscar = ''; cargar(1) }
const cambiarPagina = (p) => { if (p >= 1 && p <= pagination.value.last_page) cargar(p) }

// ---- Modal ----
const abrirModalNuevo = () => {
  editandoId.value = null
  form.value = formVacio()
  formError.value = ''
  tab.value = 'datos'
  vendedoresAsignados.value = []
  seleccionDisponibles.value = []
  seleccionAsignados.value = []
  buscarEmpleado.value = ''
  modalAbierto.value = true
}

const abrirModalEditar = async (cliente) => {
  editandoId.value = cliente.id
  form.value = {
    nombre:          cliente.nombre,
    tipo_cliente_id: cliente.tipo_cliente_id,
    rfc:                   cliente.rfc ?? '',
    regimen_fiscal:        cliente.regimen_fiscal ?? '',
    uso_cfdi:              cliente.uso_cfdi ?? '',
    codigo_postal_fiscal:  cliente.codigo_postal_fiscal ?? '',
    descripcion:           cliente.descripcion ?? '',
    abreviatura:     cliente.abreviatura ?? '',
    correo:          cliente.correo,
    descuento:       cliente.descuento,
    dias_credito:    cliente.dias_credito ?? 0,
    calle:           cliente.calle ?? '',
    num_exterior:    cliente.num_exterior ?? '',
    colonia:         cliente.colonia ?? '',
    codigo_postal:   cliente.codigo_postal ?? '',
    poblacion:       cliente.poblacion ?? '',
    municipio:       cliente.municipio ?? '',
    estado:          cliente.estado ?? '',
    pais:            cliente.pais ?? 'México',
    telefono:        cliente.telefono ?? '',
    incluir_logo:    cliente.incluir_logo ?? false,
  }
  formError.value = ''
  tab.value = 'datos'
  seleccionDisponibles.value = []
  seleccionAsignados.value = []
  buscarEmpleado.value = ''

  // Cargar vendedores actuales del cliente
  await httpVendedores.get(`/pos2/clientes/${cliente.id}/vendedores`)
  vendedoresAsignados.value = httpVendedores.data.value ?? []

  modalAbierto.value = true
}

const cerrarModal = () => {
  modalAbierto.value = false
  editandoId.value = null
  formError.value = ''
}

// ---- Acciones vendedores ----
const toggleSeleccionDisponible = (id) => {
  const idx = seleccionDisponibles.value.indexOf(id)
  if (idx === -1) seleccionDisponibles.value.push(id)
  else seleccionDisponibles.value.splice(idx, 1)
}

const toggleSeleccionAsignado = (id) => {
  const idx = seleccionAsignados.value.indexOf(id)
  if (idx === -1) seleccionAsignados.value.push(id)
  else seleccionAsignados.value.splice(idx, 1)
}

const agregarSeleccionados = () => {
  const nuevos = todosEmpleados.value.filter(e => seleccionDisponibles.value.includes(e.id))
  vendedoresAsignados.value.push(...nuevos)
  seleccionDisponibles.value = []
}

const agregarTodos = () => {
  vendedoresAsignados.value = [...todosEmpleados.value]
  seleccionDisponibles.value = []
}

const quitarSeleccionados = () => {
  vendedoresAsignados.value = vendedoresAsignados.value.filter(e => !seleccionAsignados.value.includes(e.id))
  seleccionAsignados.value = []
}

const quitarTodos = () => {
  vendedoresAsignados.value = []
  seleccionAsignados.value = []
}

const seleccionarTodosDisponibles = () => {
  seleccionDisponibles.value = empleadosFiltrados.value.map(e => e.id)
}

const seleccionarTodosAsignados = () => {
  seleccionAsignados.value = vendedoresAsignados.value.map(e => e.id)
}

// ---- Guardar ----
const guardar = async () => {
  formError.value = ''
  try {
    guardando.value = true
    let clienteId = editandoId.value

    if (clienteId) {
      await httpClientes.put(`/pos2/clientes/${clienteId}`, form.value)
    } else {
      await httpClientes.post('/pos2/clientes', form.value)
      clienteId = httpClientes.data.value.id
    }

    // Sincronizar vendedores
    await httpVendedores.put(`/pos2/clientes/${clienteId}/vendedores`, {
      empleado_ids: vendedoresAsignados.value.map(e => e.id),
    })

    cerrarModal()
    cargar(pagination.value.current_page)
  } catch (err) {
    const errors = err.response?.data?.errors
    formError.value = errors
      ? Object.values(errors).flat().join(' | ')
      : (err.response?.data?.message ?? 'Error al guardar')
  } finally {
    guardando.value = false
  }
}

const eliminar = async (cliente) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `¿Deseas eliminar a "${cliente.nombre}"?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  })
  if (result.isConfirmed) {
    try {
      await httpClientes.del(`/pos2/clientes/${cliente.id}`)
      cargar(pagination.value.current_page)
    } catch {
      Swal.fire('Error', 'No se pudo eliminar', 'error')
    }
  }
}

onMounted(() => {
  cargarTiposCliente()
  cargarEmpleados()
  cargar()
})
</script>

<style scoped>
.input-field {
  @apply w-full px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-violet-300 focus:border-violet-400;
}
.form-label {
  @apply block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1;
}
</style>
